import cn from "clsx";
import BirreteApps from "@crehana/icons/outline/BirreteApps";
import Calendar from "@crehana/icons/outline/Calendar";
import Thunder from "@crehana/icons/outline/Thunder";
import { PrimaryButton } from "@crehana/ui";
import { useLearningPlanTranslation } from "../hooks/useLearningPlanTranslation";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var iconDecorations = [Calendar, BirreteApps, Thunder];
var EditStudyPlan = function EditStudyPlan(_ref) {
  var isDark = _ref.isDark,
    onEditStudyPlan = _ref.onEditStudyPlan;
  var _useLearningPlanTrans = useLearningPlanTranslation(),
    t = _useLearningPlanTrans.t;
  return /*#__PURE__*/_jsxs("section", {
    className: cn('tw-w-full tw-h-full tw-flex tw-flex-row tw-items-center tw-flex-nowrap tw-rounded-0.8',
    // Padding
    'md:tw-p-1.2',
    // Shadow
    'tw-shadow-none md:tw-shadow-01 dark:tw-shadow-none',
    // Text color
    'tw-text-neutral-light-800 dark:tw-text-neutral-light-100',
    // Background color
    'dark:tw-bg-neutral-dark-700'),
    children: [/*#__PURE__*/_jsx("div", {
      className: "tw-flex tw-flex-col tw-mr-1.6 tw-hidden md:tw-block",
      "aria-hidden": true,
      children: iconDecorations.map(function (Icon, index) {
        return /*#__PURE__*/_jsx("div", {
          className: cn('tw-rounded-full tw-w-3.2 tw-h-3.2', isDark ? 'bg-base-lighter-24 text-secondary-main' : 'bg-primary-lighter-12 text-primary-main', {
            'tw-mb-1.2': iconDecorations.length !== index + 1
          }),
          children: /*#__PURE__*/_jsx(Icon, {
            ignoreColor: true,
            className: "tw-fill-current tw-w-full tw-mx-auto tw-mt-0.4",
            size: 20
          })
        }, index.toString());
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "tw-flex tw-flex-col tw-items-start sm:tw-justify-between md:tw-flex-col md:tw-items-start tw-w-full",
      children: [/*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("h3", {
          className: "font-subtitle3 tw-mb-0.8",
          children: t('LEARNING_PLAN_EDIT_STUDY_PLAN_TITLE')
        }), /*#__PURE__*/_jsx("p", {
          className: "font-body4 tw-mb-2",
          children: t('LEARNING_PLAN_EDIT_STUDY_PLAN_DESC')
        })]
      }), /*#__PURE__*/_jsx(PrimaryButton, {
        label: t('CREATE_STUDY_PLAN'),
        onClick: onEditStudyPlan,
        isDark: isDark,
        size: "xs"
      })]
    })]
  });
};
export default EditStudyPlan;